const features = {
  nodaFiCheck: 'nodafi_check',
  survey: 'survey',
  externalOrganizations: 'external_organizations',
  insight: 'insight',
  procedures: 'procedures',
  purchaseOrders: 'purchase_orders',
  duplicatePmsConfig: 'duplicate_pms_config',
  pmsConfigUpdates: 'pms_config_updates',
  advancedInsights: 'advanced_insights',
  duplicateLocationConfig: 'duplicate_location_config',
  pmPlanner: 'pm_planner',
  goldenBroom: 'golden_broom',
  aiReports: 'ai_reports',
  archivedTickets: 'archived_tickets',
  integrationsTab: 'integrations_tab',
  procedureEntryStatsTableWeb: 'procedure_entry_stats_table_web',
  companyRulesToggle: 'company_rules_toggle',
  aiProcedureTemplateGenerator: 'ai-procedure-template-generator',
  insightOverride: 'insight_override',
  procedureScoring: 'procedure_scoring',
  procedureFileFieldType: 'procedure_file_field_type',
  procedureSignatureFieldType: 'procedure_signature_field_type',
  bulkCreateTickets: 'bulk_create_tickets',
  conditionalFieldRequirements: 'conditional_field_requirements',
  slackIntegrations: 'slack_integrations',
  enableOrchidWebToggle: 'enable_orchid_web_toggle',
  videoAttachments: 'video_attachments',
} as const

export type FeatureGateName = (typeof features)[keyof typeof features]

export default features
